import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom";
import { notification } from "antd";
import styled from "styled-components";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { formatPrice } from "utils/helpers";
import { getDeposit, getDetailPreOrderHashcode } from "services/pre-order.service";
import { CAPACITYS, COLORS, PRODUCTS, findProduct } from "config/products";
import InformationCommon from "pages/ProductDetail/InformationCommon";
import IMAGES from "utils/images";
import { paymentType } from "./constants";
import CONFIG from "config/config";
import { sendPayoo } from "services/payment.service";
import { DEPOSIT } from "utils/contants";
import LoadingV2 from "components/shared/LoadingV2";

const antIcon = <LoadingOutlined style={{ fontSize: 100 }} spin />;

const LoadingStyled = styled(Spin)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 200px;
`;

const OrderStatus = ({ type = "STATUS" }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [preOrder, setPreOrder] = useState({});
  const { pre_order_id } = useParams();

const createdDate = new Date(preOrder?.CREATEDDATE);
const startOfSep2026 = new Date('2026-08-01T00:00:00');

const isBeforeSep2026 = createdDate < startOfSep2026;

  useEffect(() => {
    const getData = async () => {
      const res = await getDetailPreOrderHashcode(pre_order_id);
      if (!res?.data) {
        return res;
      }
      let product = PRODUCTS.find((x) => +x.productId === +res.data.PRODUCTID);
      if (product) {
        res.data.productSelect = {
          ...product,
          capacityName: CAPACITYS.find(
            (x) => x.capacityKey === product.capacityKey
          )?.name,
          colorName: COLORS.find((x) => x.colorKey === product.colorKey)
            ?.colorName,
        };
      }
      return res;
    };
    const loadPreOrder = async () => {
      setLoading(true);
      try {
        const res = await getData();
        if (!res?.data) {
          history.push("/");
          return;
        }

        setPreOrder(res.data);
        setLoading(false);
      } catch (error) {
        notification.error({
          message: error?.message ?? "Không có dữ liệu đơn hàng",
        });
      } finally {
        setLoading(false);
      }
    };
    loadPreOrder();
  }, [pre_order_id]);

  const { pathname } = useLocation();
  const isPaidPage = pathname.includes("/order-status/paid");
  const isCompletePage = pathname.includes("/order-status/complete");
  const [depositValue, setDepositValue] = useState(0);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const isPaidCompleted =
    preOrder?.PAYMENTTYPE === 1 && preOrder?.TOTALMONEY >= preOrder?.PRICE;

  if (isPaidCompleted && !isCompletePage) {
    history.push(`/order-status/complete/${preOrder?.PREORDERID}`);
  }

  const _productPrice = preOrder.PRICE || preOrder.productSelect?.price || 0;

  useEffect(() => {
    getDeposit().then((value) => setDepositValue(value?.data ?? DEPOSIT));
  }, []);

  const handleSubmitPayoo = async () => {
    try {
      setLoadingSubmit(true);
      const res = await sendPayoo({
        orderId: preOrder?.PREORDERID,
        amount: depositValue,
      });
      if (res?.data) {
        window.location.href = res?.data;
      } else if (res?.httpStatusCode === 404 && res?.success === false) {
        notification.error({ message: "Lỗi Thanh Toán!" });
        setLoadingSubmit(false);
      }
    } catch (error) {
      notification.error({ message: error?.message ?? "Lỗi Thanh Toán!" });
      setLoadingSubmit(false);
    }

  };

  const jsx_render = () => {
    return (
      <div className="page ordercomplete-page">
        <div className="page-body">
          {!isPaidCompleted && <h2>Thông tin đơn hàng</h2>}
          <div className="nav-processing">
            {type === "STATUS" && preOrder?.PAYMENTSTATUSTYPE !== 2 && (
              <img src={IMAGES.progesss_3} alt="" width="100%" height="80px" />
            )}
            {type === "STATUS" && preOrder?.PAYMENTSTATUSTYPE === 2 && (
              <img src={IMAGES.process_4} alt="" width="100%" height="80px" />
            )}
            {type === "PAID" && preOrder?.PAYMENTSTATUSTYPE !== 1 && (
              <img src={IMAGES.process_4} alt="" width="100%" height="80px" />
            )}
            {type === "PAID" && preOrder?.PAYMENTSTATUSTYPE === 1 && (
              <img src={IMAGES.process_5} alt="" width="100%" height="80px" />
            )}
            {type === "COMPLETE" && (
              <img src={IMAGES.process_5} alt="" width="100%" height="80px" />
            )}
          </div>

          <div className="all-content-ordercomplete new-container-ordercomplete">
            <div className="note-ordercomplete">
              Cảm ơn Quý khách chọn mua hàng tại ShopDunk. Trong 15 phút vui
              lòng xem Zalo / SMS hoặc cuộc gọi từ Shopdunk để kiểm tra thông
              tin đơn hàng. Các đơn hàng từ 21h30 tối tới 8h sáng hôm sau.
              ShopDunk sẽ liên hệ với Quý khách trước 10h trưa cùng ngày
            </div>
            <div className="container-ordercomplete no-w">
              <div className="title-noti">
                {preOrder?.PAYMENTTYPE === 1 &&
                  preOrder?.TOTALMONEY >= preOrder?.PRICE &&
                  (isCompletePage ? paymentType["1_PAID"] : paymentType[1])}
                {preOrder?.PAYMENTTYPE === 1 &&
                  preOrder?.TOTALMONEY < preOrder?.PRICE &&
                  paymentType[preOrder?.PAYMENTSTATUSTYPE]}
                {preOrder?.PAYMENTTYPE !== 1 && (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M35.6239 21.8751C34.3739 28.1251 29.6614 34.0101 23.0489 35.3251C19.8238 35.9674 16.4784 35.5758 13.4889 34.2061C10.4993 32.8364 8.01815 30.5585 6.39859 27.6966C4.77902 24.8347 4.10365 21.5348 4.46863 18.2668C4.83361 14.9988 6.22033 11.9292 8.43135 9.49511C12.9664 4.50011 20.6239 3.12511 26.8739 5.62511"
                        stroke="#0066CC"
                        strokeWidth="3.33333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M14.373 19.375L20.623 25.625L35.623 9.375"
                        stroke="#0066CC"
                        strokeWidth="3.33333"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <h3>Đặt hàng thành công</h3>
                  </>
                )}
              </div>

              <div className="info-ordercomplete">
                <InformationCommon preOrder={preOrder} />

                <div className="info-products">
                  <div
                    className="product-picture"
                    style={{ marginLeft: "15px", marginRight: "20px" }}
                  >
                    <img
                      src={preOrder.productSelect?.imageUrl}
                      alt=""
                      width="100%"
                      height="100%"
                      style={{
                        objectFit: "contain",
                        maxHeight: "108px",
                      }}
                    />
                  </div>

                  <div className="products">
                    <a
                      href="/#"
                      className="product-name"
                      onClick={(e) => e.preventDefault()}
                    >
                      {preOrder.productSelect?.productName}
                    </a>
                    <div className="attributes">
                      <p>Màu sắc: {preOrder.productSelect?.colorName}</p>
                      <p>Dung lượng: {preOrder.productSelect?.capacityName}</p>
                      <p>Số lượng: 1</p>
                      {!isCompletePage && !isPaidPage && (
                        <p>
                          Tổng tiền:{" "}
                          <span className="price">
                            {formatPrice(_productPrice, true)}
                          </span>
                        </p>
                      )}
                      {!isCompletePage && isPaidPage && (
                        <p>
                          Tổng tiền:{" "}
                          <span className="price">
                            {formatPrice(_productPrice, true)}
                          </span>
                          {/* <span className="price-strike sd_ml_5">
                            {formatPrice(preOrder.productSelect?.price_listed, true)}
                          </span> */}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="btn-ordercomplete">
                  {/* <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <a href="https://shopdunk.com" className="continute-button">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                      >
                        <path
                          d="M16.75 22.5C17.7165 22.5 18.5 21.7165 18.5 20.75C18.5 19.7835 17.7165 19 16.75 19C15.7835 19 15 19.7835 15 20.75C15 21.7165 15.7835 22.5 16.75 22.5Z"
                          fill="white"
                        />
                        <path
                          d="M8.75 22.5C9.7165 22.5 10.5 21.7165 10.5 20.75C10.5 19.7835 9.7165 19 8.75 19C7.7835 19 7 19.7835 7 20.75C7 21.7165 7.7835 22.5 8.75 22.5Z"
                          fill="white"
                        />
                        <path
                          d="M5.34 3.94L5.14 6.39C5.1 6.86 5.47 7.25 5.94 7.25H21.25C21.67 7.25 22.02 6.93 22.05 6.51C22.18 4.74 20.83 3.3 19.06 3.3H6.77C6.67 2.86 6.47 2.44 6.16 2.09C5.66 1.56 4.96 1.25 4.24 1.25H2.5C2.09 1.25 1.75 1.59 1.75 2C1.75 2.41 2.09 2.75 2.5 2.75H4.24C4.55 2.75 4.84 2.88 5.05 3.1C5.26 3.33 5.36 3.63 5.34 3.94Z"
                          fill="white"
                        />
                        <path
                          d="M21.0101 8.75H5.67005C5.25005 8.75 4.91005 9.07 4.87005 9.48L4.51005 13.83C4.37005 15.54 5.71005 17 7.42005 17H18.5401C20.0401 17 21.3601 15.77 21.4701 14.27L21.8001 9.6C21.8401 9.14 21.4801 8.75 21.0101 8.75Z"
                          fill="white"
                        />
                      </svg>
                      Tiếp tục mua hàng
                    </a>
                  </div> */}

                  {(preOrder?.PAYMENTSTATUSTYPE === 0 || preOrder?.PAYMENTSTATUSTYPE === 3) && !isBeforeSep2026 &&
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {loadingSubmit?
                        <div className="continute-button-div">
                          <LoadingV2 />
                        </div>
                        :
                        <div onClick={() => handleSubmitPayoo()} className="continute-button-div">
                          Tiếp tục thanh toán
                        </div>
                      }
                    </div>
                  }

                  <a
                    href="https://shopdunk.com/web-review"
                    className="feedback"
                  >
                    Góp ý về trải nghiệm mua hàng và thanh toán
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return loading ? <LoadingStyled indicator={antIcon} /> : jsx_render();
};
export default OrderStatus;
